import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './admin.routes';

import vendorManagementAdmin from './vendorManagementAdministration';
import trainingAdmin from './trainingAdministration';
import userAdmin from './userAdministration';
import customerAdmin from './customerAdministration';
import controlAdmin from './controlAdministration';
import riskAdmin from './riskAdministration';
import assetAdmin from './assetAdministration';

export default angular.module('app.components.admin', [
  ngRoute,
  vendorManagementAdmin,
  trainingAdmin,
  userAdmin,
  customerAdmin,
  controlAdmin,
  riskAdmin,
  assetAdmin
])
  .config(routes)
  .name;

console.log('app.components.admin created');
